<script>
import { uniqueId } from '../lib/helpers';
import { calculate, getCountries, getCurrentCountry } from '../lib/api';

import Cost from '../components/Cost.vue';
import Options from '../components/Options.vue';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import Collegue from '../components/Collegue.vue';

export default {
  name: 'Home',
  components: {
    Cost,
    Header,
    Footer,
    Options,
    Collegue
  },
  data() {
    return {
      cost: null,
      loading: true,
      countries: [],
      workers: [],
      currentCountryCode: 'IE'
    };
  },
  async created() {
    this.loading = true;
    this.countries = await getCountries();
    this.currentCountryCode = await getCurrentCountry();
    if (this.currentCountryCode) {
      await this.addWorker(this.currentCountryCode);
    } else {
      this.currentCountryCode = 'IE';
    }
    this.loading = false;
  },
  methods: {
    async onCalculate() {
      this.cost = await calculate(this.workers);
    },
    async addWorker(countryIso) {
      this.workers.push({
        id: uniqueId(),
        iso_code: countryIso,
        job_code: '',
        hours: 1
      });
    },
    updateWorker(value) {
      this.workers = this.workers.map(worker =>
        worker.id === value.id ? value : worker
      );
    },
    removeWorker(id) {
      this.workers = this.workers.filter(
        worker => worker.id !== id
      );
    }
  }
};
</script>

<template>
  <div class="container">
    <Header class="py-5" />

    <div class="text-center" v-if="loading">
      <h5>Loading....</h5>
    </div>

    <div class="row" v-else>
      <div class="col-md-12 order-md-1">
        <ul class="list-group">
          <li class="list-group-item" v-for="(worker, index) in workers" :key="index">
            <Collegue
              :value="worker"
              :countries="countries"
              :showRemove="workers.length > 1"
              @change="updateWorker"
              @remove="removeWorker"
            />
          </li>
        </ul>
      </div>
    </div>

    <Options @onAdd="addWorker(currentCountryCode)" @onCalc="onCalculate()" />

    <div class="row pt-5" v-if="cost">
      <Cost :cost="cost" />
    </div>

    <Footer />
  </div>
</template>
